import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Actions, Location, Partner} from '@app/shared';
import {getSafeImageUrl, ScreenService} from '@app/core';
import {GlobalValuesService} from '../../../core/services/global-values.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-info-card',
  standalone: false,

  templateUrl: './info-card.component.html',
  styleUrl: './info-card.component.less'
})
export class InfoCardComponent implements OnInit, OnDestroy, OnChanges {

  @Input() isActive: boolean = false;
  @Input() isAlert: boolean = false;
  @Input() name: string | undefined;
  @Input() icon: string | undefined;
  @Input() date: string | undefined;
  @Input() origin: Location | undefined;
  @Input() destination: Location | undefined;
  @Input() totalOrders: number | undefined;
  @Input() completedOrders: number | undefined;
  @Input() actions: Actions = {copy: true, file: true, message: true, drawer: false, select: false};
  @Input() checkboxConfig: { show: boolean; isChecked: boolean } = {show: false, isChecked: false};
  @Input() supplierId?: number;
  @Input() assignedTo?: Partner;
  @Input() state?: string | null | undefined;
  @Input() showStateBadge: boolean = false;
  @Input() flowEvents?: any[]; // EventType[] para usar con serviceOrderState pipe
  @Input() showServiceMenu: boolean = false;

  provider: Partner | undefined;
  assignedPartner: Partner | undefined;

  @Output() actionEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() checkboxEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() serviceMenuAction: EventEmitter<string> = new EventEmitter<string>();

  isMobile$;
  partnerSubscribe: Subscription | undefined;
  protected readonly getSafeImageUrl = getSafeImageUrl;

  constructor(private screenService: ScreenService, public gs: GlobalValuesService) {
    this.isMobile$ = this.screenService.isMobile$;
  }

  // Calcula el porcentaje de órdenes completadas
  get percent(): number {
    return (this.totalOrders && this.completedOrders) ? (this.completedOrders / this.totalOrders) * 100 : 0;
  }

  // Opcional: Método o getter para determinar el status
  get progressStatus(): 'exception' | 'normal' | 'success' {
    const p = this.percent;
    return p <= 15 ? 'exception' : (p <= 60 ? 'normal' : 'success');
  }

  ngOnInit() {
    this.updateAssignedPartner();
    this.partnerSubscribe = this.gs.isPartnerReady$.subscribe(value => {
      if (value) {
        this.provider = this.gs.providerList.find(p => p.id === this.supplierId);
        this.updateAssignedPartner();
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['assignedTo'] || changes['supplierId']) {
      this.updateAssignedPartner();
    }
  }

  updateAssignedPartner(): void {
    if (this.assignedTo) {
      this.assignedPartner = this.assignedTo;
    } else if (this.supplierId && this.gs.isPartnerReady$.value) {
      this.assignedPartner = this.gs.providerList.find(p => p.id === this.supplierId);
    } else {
      this.assignedPartner = undefined;
    }
  }

  ngOnDestroy() {
    this.partnerSubscribe?.unsubscribe();
  }

  onAction(action: string): void {
    this.actionEvent.emit(action);
  }

  checkboxChange(): void {
    this.checkboxEvent.emit();
  }

  onServiceMenuClick(action: string): void {
    this.serviceMenuAction.emit(action);
  }

  getInitials(partner: Partner | undefined): string {
    if (!partner) return '??';
    const firstName = partner.name?.charAt(0) || '';
    const lastName = partner.surName?.charAt(0) || '';
    const initials = (firstName + lastName).toUpperCase();
    return initials || '??';
  }
}
